import { MultiEmailTag } from '@synoptic/ui-kit/multi-email/multi-email.js';
import { MultiSelectCombobox } from '@synoptic/ui-kit/multi-select-combobox/multi-select-combobox.js';
import { MultiSelectMenuContainer } from '@synoptic/ui-kit/multi-select-combobox/multi-select-group.js';
import { UserCardFragmentFragment } from '@/__generated__/graphql';
import { PaginatedMultiSelectResult } from '@/components/stream-deck/list-form/typeahead-multiselect/paginated-multiselect-result';
import { UserListItem } from '@/components/users/users-multi-select-combobox/user-list-item';

type UsersMultiSelectComboboxBaseProps = {
  wrapperClassName?: string;
  selectedUsers: UserCardFragmentFragment[];
  setSelectedUsers: (users: UserCardFragmentFragment[]) => void;
  error?: string;
  setError?: (error?: string) => void;
  users: UserCardFragmentFragment[] | undefined;
  onInputChange: (value: string) => void;
  isLoading: boolean;
  label?: string;
};

export const UsersMultiSelectComboboxBase = ({
  wrapperClassName,
  selectedUsers,
  setSelectedUsers,
  error,
  setError,
  users,
  onInputChange,
  isLoading,
  label,
}: UsersMultiSelectComboboxBaseProps) => {
  return (
    <MultiSelectCombobox<UserCardFragmentFragment>
      dropdownItems={users || []}
      onInputChange={(inputValue) => {
        onInputChange(inputValue || '');
      }}
      errorMessage={error}
      label={label || 'Name or username'}
      selectedItems={selectedUsers}
      setSelectedItems={(v) => {
        if (v) {
          setSelectedUsers(v);
          // Clear error when user makes a selection
          if (error) {
            setError?.(undefined);
          }
        }
      }}
      isLoading={isLoading}
      isItemSelected={(item) => !!selectedUsers.find((v) => v.id === item.id)}
      getItemId={(item) => item.id}
      renderDropdownItems={({ getItemProps }) => (
        <MultiSelectMenuContainer>
          <PaginatedMultiSelectResult<UserCardFragmentFragment>
            emptyPlaceholder={
              // show different empty states for initial empty state and when no users found
              users?.length === 0
                ? 'No users found'
                : 'Try searching for people'
            }
            items={users || []}
            selectedItems={selectedUsers}
            getItemProps={getItemProps}
            isInitialLoading={isLoading}
            showMaxItemsHint={true}
          >
            {(item) => <UserListItem userId={item.id} />}
          </PaginatedMultiSelectResult>
        </MultiSelectMenuContainer>
      )}
      renderItemPill={(source, onRemove) => (
        <MultiEmailTag
          removeEmail={(e) => {
            onRemove(e);
          }}
        >
          {source.fullName}
        </MultiEmailTag>
      )}
      wrapperClassName={wrapperClassName}
    />
  );
};
